export default class PdvVendaProduto {
  constructor({
    product = {},
    price = 0.1,
    totalPrice = 0.1,
    quantity = 1,
    currentIndex = null,
    active = true,
    discount = 0,
    discountIsPercentage = false,
  }) {
    this.product = product;
    this.price = price;
    this.totalPrice = totalPrice;
    this.quantity = quantity;
    this.currentIndex = currentIndex;
    this.active = active;
    this.discount = discount;
    this.totalDiscount = discount;
    this.discountIsPercentage = discountIsPercentage;
  }
}
